import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { finishLoading, setError, startLoading, unsetError } from '../../../../../actions/ui';
import { activateAccount } from '../../../../../helpers/auth-helper';
import { generateSecurePassword } from '../../../../../helpers/password-helper';
import { PasswordInput } from '../register/components/PasswordInput';
import { AuthLayout } from '../AuthLayout';

export const ActivateAccount = () => {
    const dispatch = useDispatch();
    const { error, loading } = useSelector((state) => state.ui);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [successMessage, setSuccessMessage] = useState(null);
    const [searchParams] = useSearchParams();

    const token = searchParams.get('token')?.trim() || '';

    const handleInputChange = ({ target }) => {
        if (target.name === 'password') {
            setPassword(target.value);
        }
        if (target.name === 'confirmPassword') {
            setConfirmPassword(target.value);
        }
    };

    const handlePasswordGenerate = () => {
        const newPassword = generateSecurePassword(16);
        setPassword(newPassword);
        setConfirmPassword(newPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage(null);
        dispatch(unsetError());

        if (!token) {
            dispatch(setError('El enlace de activación es inválido o expiró.'));
            return;
        }

        if (password !== confirmPassword) {
            dispatch(setError('Las contraseñas no coinciden.'));
            return;
        }

        dispatch(startLoading());
        const resp = await activateAccount(token, password);

        if (resp.success) {
            setSuccessMessage(resp.message || 'Tu cuenta fue activada correctamente.');
            setPassword('');
            setConfirmPassword('');
        } else {
            dispatch(setError(resp.message || 'No se pudo activar la cuenta.'));
        }

        dispatch(finishLoading());
    };

    return (
        <AuthLayout>
            <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
                <div className="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
                    <img src="/assets/logo/logo-abbr.png" alt="" className="img-fluid" />
                </div>
                <div className="card-body p-sm-5">
                    <h2 className="fs-20 fw-bolder mb-4">Activa tu cuenta</h2>
                    <h4 className="fs-13 fw-bold mb-2">Define tu contraseña inicial</h4>
                    <p className="fs-12 fw-medium text-muted">Completa la contraseña para habilitar tu acceso.</p>

                    {error && (
                        <div className="alert alert-danger mt-3" role="alert">
                            {error}
                        </div>
                    )}

                    {successMessage && (
                        <div className="alert alert-success mt-3" role="alert">
                            {successMessage}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="w-100 mt-4 pt-2">
                        {!successMessage && (
                            <div className="mb-4">
                                <PasswordInput
                                    name="password"
                                    placeholder="Nueva contraseña"
                                    value={password}
                                    onChange={handleInputChange}
                                    showGenerator={true}
                                    onPasswordGenerate={handlePasswordGenerate}
                                />
                            </div>
                        )}
                        {!successMessage && (
                            <div className="mb-4">
                                <PasswordInput
                                    name="confirmPassword"
                                    placeholder="Confirmar contraseña"
                                    value={confirmPassword}
                                    onChange={handleInputChange}
                                    showGenerator={false}
                                />
                            </div>
                        )}
                        {!successMessage && (
                            <div className="mt-5">
                                <button type="submit" className="btn btn-lg btn-primary w-100" disabled={loading}>Activar cuenta</button>
                            </div>
                        )}
                    </form>

                    <div className="mt-5 text-muted">
                        <span> ¿Ya tienes cuenta activa?</span> <a href="/auth/login" className="fw-bold">Inicia sesión</a>
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
};
